import $ from 'jquery';
import {loadPosts} from "../utils/fetch-posts";
import LazyLoad from 'vanilla-lazyload';
import AOS from 'aos';

$(function() {

    // Setup image lazy loader
    new LazyLoad();

    // Setup animate on scroll
    AOS.init({
        duration: 1000,
        once: true,
    });

    // Add class when page is scrolled
    $(window).scroll(scrollCheck);

    // Check scroll on page load
    scrollCheck();

    // Menu toggle
    $('.js-menu-btn').on('click', function() {
        $('.aside-nav').toggleClass('active');
    });

    // Hero scroll to next section
    $('.js-next-section').on('click', function() {
        const $blocks = $('.js-blocks');
        $("html, body").animate(
            {scrollTop: $blocks.offset().top - 100,},
            1000
        );
    });

    // Posts grid load more
    $('.js-posts-load-more').on('click', function() {
        loadPosts({
            page: $('.js-posts-grid').attr('data-page'),
        });
    });

});

/**
 * Check if the page has been scrolled at all, apply header
 * class if scrolled.
 */
function scrollCheck() {
    if ($(window).scrollTop() >= 75) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }
}

